/**
 * @description Centralized query keys for buyCredits module
 * @author Omar Sanchez Martinez
 * @since 2025-10-17
 */

export const buyCreditsKeys = {
  // Base key for all buy credits queries
  all: () => ['buyCredits'] as const,

  // Subscription plans queries
  plans: () => [...buyCreditsKeys.all(), 'plans'] as const,

  // Pre-orders queries
  preOrders: () => [...buyCreditsKeys.all(), 'preOrders'] as const,
  preOrder: (subscriptionPlanId: number) =>
    [...buyCreditsKeys.preOrders(), subscriptionPlanId] as const,

  // Payment orders queries
  paymentOrders: () => [...buyCreditsKeys.all(), 'paymentOrders'] as const,
  paymentOrder: (paymentGatewayOrderId: string) =>
    [...buyCreditsKeys.paymentOrders(), paymentGatewayOrderId] as const,

  // Promotional codes queries
  promotionalCodes: () => [...buyCreditsKeys.all(), 'promotionalCodes'] as const,
  promotionalCode: (code: string, subscriptionPlanId: number) =>
    [...buyCreditsKeys.promotionalCodes(), code, subscriptionPlanId] as const,
} as const;
